import React from "react";
import Card from "canvas-core-react/lib/Card";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import TextBody from "canvas-core-react/lib/TextBody";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";

interface TitleTextProps {
  title?: string;
  content?: string;
}

export const TitleText = ({ title = "", content = "" }: TitleTextProps) => {
  return (
    <Card data-testid="titleText">
      {title?.trim() !== "" && (
        <Margin xs={6} sm={6} md={6} lg={6}>
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <TextSubtitle component="span">{title}</TextSubtitle>
            </Column>
          </Row>
        </Margin>
      )}
      {content?.trim() !== "" && (
        <Margin xs={6} sm={6} md={6} lg={6}>
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <TextBody component="span">{content}</TextBody>
            </Column>
          </Row>
        </Margin>
      )}
    </Card>
  );
};
